import { render } from "./SvgCursor.vue?vue&type=template&id=774f1443"
import script from "./SvgCursor.vue?vue&type=script&lang=js"
export * from "./SvgCursor.vue?vue&type=script&lang=js"

import exportComponent from "/builds/tumeda/flui3dbeta/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__